import React, {useLayoutEffect, useRef, useState} from 'react'

/**
 * Collapses long content to `lines` via CSS line-clamp and reveals a more/less
 * toggle only when the content actually overflows. Replaces `react-show-more`,
 * whose DOM measuring (`Truncate`) throws `removeChild … parentNode is null`
 * under React 18/19 concurrent rendering.
 */
export default function ShowMore({
    lines = 10,
    children,
}: {
    lines?: number
    children: React.ReactNode
}) {
    const [expanded, setExpanded] = useState(false)
    const [overflowing, setOverflowing] = useState(false)
    const ref = useRef<HTMLDivElement>(null)

    useLayoutEffect(() => {
        const el = ref.current
        if (el) {
            setOverflowing(el.scrollHeight > el.clientHeight + 1)
        }
    }, [children, lines])

    const clampStyle: React.CSSProperties = {
        display: '-webkit-box',
        WebkitLineClamp: lines,
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
    }

    return (
        <div>
            <div ref={ref} style={expanded ? undefined : clampStyle}>
                {children}
            </div>
            {overflowing && (
                <a
                    href="#show-more"
                    className="text-muted small"
                    onClick={(e) => {
                        e.preventDefault()
                        setExpanded((v) => !v)
                    }}
                >
                    {expanded ? 'Show less' : 'Show more'}
                </a>
            )}
        </div>
    )
}
